











































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({ components: { VCDateTimePicker } })
export default class PemantauanAnestesiTeknik extends Vue {
  @Prop() pemantauan!: any;
  @Prop({ default: false }) readonly!: boolean;

  valid = false;
  // Diisi lokal, disimpan oleh tombol Simpan milik stepper.
  dirty = false;

  asaOptions = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "E", value: "E" }
  ];

  posisiOptions = ["Supinasi", "SIM", "Pronasi", "Litotomi", "Dorsal Recomben"];

  posisiPasien = "";

  airwayOptions = [
    { text: "Face Mask", value: "face_mask" },
    { text: "ETT", value: "ett" },
    { text: "LMA", value: "lma" }
  ];

  form: any = {
    asa_status: "2",
    informed_consent: true,
    kesiapan_anestesi: true,
    jenis_anestesi: "general",
    mulai_anestesi_at: "",
    akhir_anestesi_at: "",
    mulai_operasi_at: "",
    akhir_operasi_at: ""
  };

  agenForm: any = {
    halothane: false,
    ether: false,
    isoflurane: false,
    sevoflurane: false,
    n2o: false,
    o2_persen: null,
    o2_lpm: null
  };

  regionalForm: any = {
    posisi_pasien: "",
    daerah_pemasangan: "",
    jarum_no: "",
    catheter_epidural: false,
    obat_obat: ""
  };

  generalForm: any = {
    tiva: false,
    airway_device: "ett",
    ett_size: "",
    pemeliharaan: "",
    pernafasan: "kendali"
  };

  premedikasiItems: any[] = [];
  induksiItems: any[] = [];

  mounted() {
    this.loadData();
  }

  @Watch("pemantauan")
  onPemantauanChanged() {
    if (this.dirty) return;
    this.loadData();
  }

  @Watch("form", { deep: true })
  @Watch("agenForm", { deep: true })
  @Watch("regionalForm", { deep: true })
  @Watch("generalForm", { deep: true })
  @Watch("posisiPasien")
  @Watch("premedikasiItems", { deep: true })
  @Watch("induksiItems", { deep: true })
  onFormChanged() {
    this.dirty = true;
  }

  loadData() {
    if (!this.pemantauan) return;

    this.form.asa_status = this.pemantauan.asa_status || "2";
    this.form.informed_consent = this.pemantauan.informed_consent ?? true;
    this.form.kesiapan_anestesi = this.pemantauan.kesiapan_anestesi ?? true;
    this.form.jenis_anestesi = this.pemantauan.jenis_anestesi || "general";
    this.form.mulai_anestesi_at = this.pemantauan.mulai_anestesi_at
      ? moment(this.pemantauan.mulai_anestesi_at).format("YYYY-MM-DDTHH:mm")
      : "";
    this.form.akhir_anestesi_at = this.pemantauan.akhir_anestesi_at
      ? moment(this.pemantauan.akhir_anestesi_at).format("YYYY-MM-DDTHH:mm")
      : "";
    this.form.mulai_operasi_at = this.pemantauan.mulai_operasi_at
      ? moment(this.pemantauan.mulai_operasi_at).format("YYYY-MM-DDTHH:mm")
      : "";
    this.form.akhir_operasi_at = this.pemantauan.akhir_operasi_at
      ? moment(this.pemantauan.akhir_operasi_at).format("YYYY-MM-DDTHH:mm")
      : "";

    if (this.pemantauan.agen_anestesi) {
      Object.assign(this.agenForm, this.pemantauan.agen_anestesi);
    }
    if (this.pemantauan.regional_detail) {
      Object.assign(this.regionalForm, this.pemantauan.regional_detail);
    }
    if (this.pemantauan.general_detail) {
      Object.assign(this.generalForm, this.pemantauan.general_detail);
    }
    this.posisiPasien =
      (this.pemantauan.regional_detail || {}).posisi_pasien ||
      (this.pemantauan.general_detail || {}).posisi_pasien ||
      "";

    this.premedikasiItems = this.pemantauan.premedikasi
      ? [...this.pemantauan.premedikasi]
      : [];
    this.induksiItems = this.pemantauan.induksi
      ? [...this.pemantauan.induksi]
      : [];

    this.$nextTick(() => {
      this.dirty = false;
    });
  }

  get waktuDate() {
    const ke = (v: string) => (v ? moment(v).toDate() : null);
    return {
      mulai_anestesi_at: ke(this.form.mulai_anestesi_at),
      akhir_anestesi_at: ke(this.form.akhir_anestesi_at),
      mulai_operasi_at: ke(this.form.mulai_operasi_at),
      akhir_operasi_at: ke(this.form.akhir_operasi_at)
    };
  }

  setWaktu(field: string, val: Date | null) {
    if (this.readonly) return;
    this.$set(this.form, field, val ? moment(val).format("YYYY-MM-DDTHH:mm") : "");
  }

  isiSekarang(field: string) {
    if (this.readonly) return;
    this.$set(this.form, field, moment().format("YYYY-MM-DDTHH:mm"));
  }

  validateStep(): boolean {
    return (this.$refs.form as any).validate();
  }

  collectPayload(): any {
    const data: any = {
      asa_status: this.form.asa_status,
      informed_consent: this.form.informed_consent,
      kesiapan_anestesi: this.form.kesiapan_anestesi,
      jenis_anestesi: this.form.jenis_anestesi,
      agen_anestesi: this.agenForm,
      premedikasi: this.premedikasiItems.filter(i => i.obat || i.obat_tindakan),
      induksi: this.induksiItems.filter(i => i.obat_tindakan),
      mulai_anestesi_at: this.form.mulai_anestesi_at || null,
      akhir_anestesi_at: this.form.akhir_anestesi_at || null,
      mulai_operasi_at: this.form.mulai_operasi_at || null,
      akhir_operasi_at: this.form.akhir_operasi_at || null
    };

    const posisi = (this.posisiPasien || "").trim();
    if (
      this.form.jenis_anestesi === "regional" ||
      this.form.jenis_anestesi === "combined"
    ) {
      data.regional_detail = { ...this.regionalForm, posisi_pasien: posisi };
    }
    if (
      this.form.jenis_anestesi === "general" ||
      this.form.jenis_anestesi === "combined"
    ) {
      data.general_detail = { ...this.generalForm, posisi_pasien: posisi };
    }

    return data;
  }

  isDirty(): boolean {
    return this.dirty;
  }

  markSaved() {
    this.dirty = false;
  }
}
